import { Create, SimpleForm } from 'react-admin';
import { EnterSubmitBlockingSimpleFormContent } from 'src/client/components/forms/form-components';
import { AdvertiserFormFields, transformAdvertiserInput } from './shared';

export const AdvertiserCreate = () => (
  <Create transform={transformAdvertiserInput} redirect="list">
    <SimpleForm component={EnterSubmitBlockingSimpleFormContent}>
      <AdvertiserFormFields title="Create Advertiser" showAdServerId={false} />
    </SimpleForm>
  </Create>
);
